
import { ClockCircleOutlined, HddOutlined, TruckOutlined, LikeOutlined, RetweetOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { Input, Tag, Button } from 'antd';
import { numberFormatter } from './numberFormatter';

const creditFormatter = (value, record) => {

    if (record.isOut) {
      return numberFormatter(value)
    }

}

const debitFormatter = (value, record) => {

  if (!record.isOut) {
    return numberFormatter(value);
  }

}

const quantityOutFormatter = (value, record) => {
  if (!record.transaction?.isOut) {
    return numberFormatter(value)
  }

}

const quantityInFormatter = (value, record) => {

if (record.transaction?.isOut) {
  return numberFormatter(value);
}

}

const typeFormatter = (type, record) => {

  if(record.isBank){
    type =  type = `Bank ${type}`;
  }
  if (record.isCredit) {
    return <Tag color="#f0b103"
      style={{ cursor: 'pointer', fontSize: '15px', width: '90%', textAlign: "center" }}>{type}</Tag>
  }
  else {
    if (record.isOut) {
      return <Tag color="#ff4364"
        style={{ cursor: 'pointer', fontSize: '15px', width: '90%', textAlign: "center" }}>{type}</Tag>
    } else {
      return <Tag color="#2eb85c"
        style={{ cursor: 'pointer', fontSize: '15px', width: '90%', textAlign: "center" }}>{type}</Tag>
    }
  }

}


const stockActivitytypeFormatter = (transaction, record) => {

  if (!transaction.isOut) {
    return <Tag color="#ff4364"
      style={{ cursor: 'pointer', fontSize: '15px', width: '90%', textAlign: "center" }}>{transaction.type}</Tag>
  } else {
    return <Tag color="#2eb85c"
      style={{ cursor: 'pointer', fontSize: '15px', width: '90%', textAlign: "center" }}>{transaction.type}</Tag>
  }

}

const productSalesFormatter = (transaction, record) => {

  if (transaction.isOut) {
    return <Tag color="#ff4364"
      style={{ cursor: 'pointer', fontSize: '15px', width: '90%', textAlign: "center" }}>{transaction.type}</Tag>
  } else {
    return <Tag color="#2eb85c"
      style={{ cursor: 'pointer', fontSize: '15px', width: '90%', textAlign: "center" }}>{transaction.type}</Tag>
  }

}


const paymentTypeFormatter = (isCredit, record) => {
  if (isCredit) {
    return <Tag color="#f0b103"
      style={{ cursor: 'pointer', fontSize: '15px', width: '80%', textAlign: "center" }}>Credit</Tag>
  } else if (record.isOut) {
    return <Tag color="#ff4364"
      style={{ cursor: 'pointer', fontSize: '15px', width: '80%', textAlign: "center" }}>Cash</Tag>
  } else {
    return <Tag color="#2eb85c"
      style={{ cursor: 'pointer', fontSize: '15px', width: '80%', textAlign: "center" }}>Cash</Tag>
  }

}

export {
  creditFormatter,
  debitFormatter,
  typeFormatter,
  paymentTypeFormatter,
  stockActivitytypeFormatter,
  productSalesFormatter,
  quantityOutFormatter,
  quantityInFormatter
};